import { Router, scrollBehavior } from '@/utils/router.js';
import { setHtmlMeta } from '@/utils/utils';

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      redirect: { name: 'Aboutus' },
      meta: { 
        title: '',
        keywords: '',
        description: 'YorkBBS was founded in 2002. As the most visited Chinese portals in Canada',
       },
    },
    {
      path: '/aboutus',
      name: 'Aboutus',
      component: () => import(/* webpackChunkName: "core_corp" */ './about/about.vue'),
      meta: { 
        title: '关于我们 - 约克论坛',
        keywords: 'Yorkbbs.ca,加拿大华人中文网,多伦多华人网,多伦多新闻,华人论坛',
        description: '约克论坛（yorkbbs.ca）是加拿大第一中文门户网站，是多伦多最具影响力的中文网络媒体！',
       },
    },
    {
      path: '/ads',
      name: 'Ads',
      component: () => import(/* webpackChunkName: "core_corp" */ './adv/adv.vue'),
      meta: { 
        title: '广告服务 - 约克论坛',
        keywords: 'Yorkbbs.ca,加拿大华人中文网,多伦多华人网,华人论坛,报价单,广告方案',
        description:
          '约克论坛（yorkbbs.ca）全面整合营销解决方案，为您量身定制最优的广告方案，查询报价单，电话416-915-5056或416-628-9108。',
       },
    },
    {
      path: '/contact',
      name: 'Contact',
      component: () => import(/* webpackChunkName: "core_corp" */ './contact/contact.vue'),
      meta: {
        title: '联系方式 - 约克论坛',
        keywords: '约克论坛官方微信,约克论坛客服,yorkbbs wechat',
        description:
          '约克论坛客服24小时服务在线，微信号: yorkbbsad，电话416-915-5056或416-628-9108，邮箱: info@yorkbbs.ca。',
      },
    },
    {
      path: '/concat',
      redirect: '/contact',
    },
    {
      path: '/delete/account',
      name: 'DeleteAccount',
      component: () => import(/* webpackChunkName: "core_corp" */ './deleteAccount/deleteAccount.vue'),
      meta: {
        title: '联系方式 - 约克论坛',
        keywords: '约克论坛官方微信,约克论坛客服,yorkbbs wechat',
        description:
          '约克论坛客服24小时服务在线，微信号: yorkbbsad，电话416-915-5056或416-628-9108，邮箱: info@yorkbbs.ca。',
      },
    },
    {
      path: '/memorabilia',
      name: 'Memorabilia',
      component: () => import(/* webpackChunkName: "core_corp" */ './memorabilia/memorabilia.vue'),
      meta: { 
        title: '大事记 - 约克论坛',
        keywords: 'Yorkbbs.ca,加拿大华人中文网,多伦多华人网,多伦多新闻,华人论坛',
        description:
          '约克论坛（yorkbbs.ca）的成长记录，汇聚了约克宝贝、美食大赛、摄影比赛、征文大赛等多伦多华人喜爱的活动。',
       },
    },
    {
      path: '/policy',
      name: 'Policy',
      component: () => import(/* webpackChunkName: "core_corp" */ './exemption/exemption.vue'),
      meta: { 
        title: '免责声明 - 约克论坛',
        keywords: 'Yorkbbs.ca,加拿大华人中文网,多伦多华人网,多伦多新闻,华人论坛',
        description: '约克论坛（yorkbbs.ca）向多伦多华人和留学生提供沟通交流平台，会员需对自己发布的信息和言论负责。',
       },
    },
    {
      path: '/maps',
      name: 'Maps',
      component: () => import(/* webpackChunkName: "core_corp" */ './maps/maps.vue'),
      meta: { 
        title: '网址导航 - 约克论坛',
        keywords: 'Yorkbbs.ca,加拿大华人中文网,多伦多华人网,多伦多新闻,华人论坛',
        description: '约克论坛（yorkbbs.ca）网址导航，为多伦多华人和留学生提供加拿大新闻、房产、汽车、黄页、美食、旅游、留学移民、财经、招聘、二手、活动优惠等生活信息。',
      },
    },
    {
      path: '/index',
      name: 'Index',
      component: () => import(/* webpackChunkName: "core_corp" */ './en/en.vue'),
      meta: { 
        title: 'About YorkBBS',
        keywords:'Yorkbbs.ca,加拿大华人中文网,多伦多华人网,多伦多新闻,华人论坛',
        description: 'YorkBBS is the No.1 Chinese portals and the most influential Chinese network media in Toronto Canada，providing information covering Canada news, housing, car, yellowpage, restaurants, travel, education, immigrant, investment, hiring, forsale and so on.',
       },
    },
    {
      path: '/paypal',
      name: 'Paypal',
      component: () => import(/* webpackChunkName: "core_corp" */ './paypal/paypal.vue'),
      meta: { desc: '含税订单' },
    },
    {
      path: '/pay',
      name: 'Pay',
      component: () => import(/* webpackChunkName: "core_corp" */ './pay/pay.vue'),
      meta: { desc: '不含税订单' },
    },
    {
      path: '/paysuc',
      name: 'Paysuc',
      component: () => import(/* webpackChunkName: "core_corp" */ './paysuc/paysuc.vue'),
      meta: { desc: '支付成功', keywords: '', description: ''},
    },
    {
      path: '/websafe',
      name: 'WebSafe',
      component: () => import(/* webpackChunkName: "core_corp" */ '@/common/websafe.vue'),
      meta:{
        title: '外链 - 约克论坛', keywords: '', description: ''
      }
    },
    {
      path: '/app',
      name: 'Download',
      component: () => import(/* webpackChunkName: "core_corp" */ './download/download.vue'),
      meta: { 
        title: '约克论坛移动客户端',
        keywords:
          '约克论坛iPhone App,约克论坛安卓App,约克论坛移动app,约克论坛移动客户端,YorkBBS iPhone客户端,YorkBBS Android客户端',
        description:'',
      },
    },
    {
      path: '/download',
      name: 'Download',
      component: () => import(/* webpackChunkName: "core_corp" */ './download/download.vue'),
      meta: { 
        title: '约克论坛移动客户端',
        keywords:
          '约克论坛iPhone App,约克论坛安卓App,约克论坛移动app,约克论坛移动客户端,YorkBBS iPhone客户端,YorkBBS Android客户端',
        description:'',
       },
    },
    {
      path: '/404',
      name: 'NotFound',
      component: () => import(/* webpackChunkName: "core_corp" */ '@/common/404/index.vue'),
      meta: { title: '404 - 约克论坛', keywords: '', description: '' },
    },
    {
      path: '*',
      redirect: '/404',
    },
  ],
  scrollBehavior,
});

router.beforeEach((to, from, next) => {
  setHtmlMeta(to.meta);

  if (to.name == 'NotFound' && !to.query.from) return next({ name: 'NotFound', query: { from: location.href } });

  next();
});

export { router };
